import React from 'react';

import { Issue, PollDayLink } from 'api/api.types';
import Downloads from './Downloads';
import Links from './Links';

interface Props {
  id: string;
  hasDownloads: boolean;
  links?: PollDayLink[];
  issues?: Issue[];
  headingLevel?: 2 | 3;
}

const AdditionalResources = ({
  id,
  hasDownloads,
  links,
  issues,
  headingLevel,
}: Props) => {
  if (!hasDownloads && !links) return null;

  return (
    <div className="wap__additional-resources">
      {hasDownloads && <Downloads id={id} issues={issues} headingLevel={headingLevel} />}
      {Boolean(links?.length) && <Links links={links} headingLevel={headingLevel} />}
    </div>
  );
};

export default AdditionalResources;
